/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ThreeDot } from "react-loading-indicators";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDocumentById,
  getAllDocuments,
  getDocTypeApi,
  updateDocumentNameApi,
} from "../../../../Services/DocumentUpload/documentUploadApi";
import { toast } from "react-toastify";
import { capitalizeWords, formatDate } from "../../../../Utils/LetterCase";
import PaginationComponent from "../../../Pagination/pagination";
import DeleteDocument from "./DeleteDocument";
import EditDocument from "./EditDocument";

const DocumentTable = ({ communityIdForDoc }) => {
  const dispatch = useDispatch();
  const [privatetypeId, setPrivatetypeId] = useState();
  const [publictypeId, setPublictypeId] = useState();
  const [docTypes, setDocTypes] = useState();
  const [documents, setDocuments] = useState([]);
  const [search, setSearch] = useState("");
  const [fileNameToEdit, setFileNameToEdit] = useState();
  const [documentIdForEdit, setDocumentIdForEdit] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();
  const [modalShow, setModalShow] = React.useState(false);
  const [refetch, setRefetch] = useState(false);
  const [versionDateToEdit, setVersionDateToEdit] = useState(null);
  const { allDocs, loading } = useSelector((state) => state.getAllDocument);
  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    setCount(allDocs?.count);
    setDocuments(allDocs?.data);
  }, [allDocs?.count, allDocs?.data]);

  useEffect(() => {
    dispatch(getDocTypeApi())
      .unwrap()
      .then((res) => {
        setDocTypes(res.data);
      })
      .catch((err) => {
        toast.error("Failed to fetch document types.");
      });
  }, [dispatch]);

  useEffect(() => {
    if (docTypes?.length > 0) {
      const privatetypeId =
        docTypes?.find((type) => type.name === "private")?.id || null;

      setPrivatetypeId(privatetypeId);

      const publictypeId =
        docTypes?.find((type) => type.name === "public")?.id || null;

      setPublictypeId(publictypeId);
    }
  }, [docTypes]);

  useEffect(() => {
    dispatch(
      getAllDocuments({
        community_id: communityIdForDoc,
        page: page,
        page_size: pageSize,
        search: search,
        access: "all",
        user_id: userId,
      })
    )
      .unwrap()
      .catch((err) => {
        toast.error("Failed to fetch document.");
      });
  }, [dispatch, refetch, page, pageSize, search, communityIdForDoc, userId]);

  const handleGetByIdDocument = async (id, e) => {
    try {
      const response = await dispatch(fetchDocumentById(id)).unwrap();
      const documentUrl = response?.data?.community_documents;

      if (documentUrl) {
        window.open(documentUrl, "_blank"); // Opens the URL in a new tab
      } else {
        toast.error("Document URL not found.");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      toast.error("Failed to fetch document.");
    }
  };

  const handleToggle = (document_id, currentId, currentDocument) => {
    const updatedId =
      currentId === privatetypeId ? publictypeId : privatetypeId;
    let updatedDocTypeDisplay =
      currentDocument.doc_type_display === "private" ? "Public" : "Private";

    setDocuments((prevDocuments) =>
      prevDocuments.map((doc) =>
        doc.id === document_id
          ? {
              ...doc,
              doc_type: updatedId,
              doc_type_display: updatedDocTypeDisplay,
            } // Update all necessary fields
          : doc
      )
    );

    const documents = [
      {
        id: document_id,
        doc_type_id: updatedId,
      },
    ];

    dispatch(
      updateDocumentNameApi({
        // document_id: document_id,
        // doc_type: updatedId,
        documents: documents,
      })
    )
      .then(() => {
        setDocuments((prevDocuments) =>
          prevDocuments.map((doc) =>
            doc.id === document_id ? { ...doc, doc_type: updatedId } : doc
          )
        );
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
      });
  };

  return (
    <div>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "25vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#e55426" size="small" text="" textColor="" />
        </Box>
      ) : (
        <>
          <div className="title-search-block d-flex justify-content-between align-items-center">
            <div className="allcommunities mt-4 mx-4">Uploaded Documents</div>
            <div className="searchbar mt-4 mx-4">
              <input
                type="search"
                placeholder="Search..."
                className="inputsearch"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="upload-docs-block">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    <a href="#">Document Name</a>
                  </th>
                  <th>
                    <a href="#">View Type</a>
                  </th>
                  <th>
                    <a href="">Date Uploaded</a>
                  </th>
                  <th>
                    <a href="">Version Date</a>
                  </th>
                  <th>
                    <a href="">Rules Verified</a>
                  </th>
                  <th>
                    <a href="#">Action</a>
                  </th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((data, index) => (
                  <tr key={data.id}>
                    <td>
                      <div className="d-flex justify-content-between">
                        {data?.document_name}
                      </div>
                    </td>
                    <td>
                      <div className="toggle-switch">
                        <input
                          type="checkbox"
                          id={`toggle-${data.id}`} // Make the id unique by appending user.id
                          checked={data?.doc_type === publictypeId}
                          onChange={() =>
                            handleToggle(data?.id, data?.doc_type, data)
                          }
                        />
                        <label className="slider" htmlFor={`toggle-${data.id}`}>
                          <span className="visually-hidden">
                            Toggle document visibility
                          </span>
                        </label>{" "}
                        {/* Match the id in label */}
                      </div>
                      {capitalizeWords(
                        data?.doc_type === publictypeId ? "Public" : "Private"
                      )}
                    </td>
                    <td>{formatDate(data.created_date)}</td>
                    <td>{data.version_date}</td>
                    <td>{data?.is_rules_verified ? "Yes" : "No"}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a title="Edit" style={{ cursor: "pointer" }}>
                          <div
                            className="edit"
                            onClick={() => {
                              setFileNameToEdit(data?.document_name);
                              setVersionDateToEdit(data.version_date);
                              setDocumentIdForEdit(data?.id);
                              setModalShow(true);
                            }}
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 13 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_101_3493)">
                                <path
                                  d="M11.9985 8.63379C11.8196 8.63379 11.6747 8.77871 11.6747 8.95756V11.8323C11.6741 12.3685 11.2396 12.803 10.7034 12.8036H1.61884C1.08258 12.803 0.648182 12.3685 0.647534 11.8323V3.3952C0.648182 2.85908 1.08261 2.42455 1.61884 2.4239H4.49357C4.67238 2.4239 4.81733 2.27895 4.81733 2.10013C4.81733 1.92141 4.67238 1.77637 4.49357 1.77637H1.61884C0.725174 1.77737 0.00100368 2.50154 0 3.3952V11.8324C0.00100368 12.726 0.725174 13.4502 1.61884 13.4512H10.7034C11.5971 13.4502 12.3213 12.726 12.3223 11.8324V8.95756C12.3223 8.77871 12.1773 8.63379 11.9985 8.63379Z"
                                  fill="#414141"
                                />
                                <path
                                  d="M12.1943 0.943343C11.6253 0.374354 10.7028 0.374354 10.1338 0.943343L4.35758 6.71958C4.31804 6.75911 4.28942 6.80821 4.2745 6.8621L3.51491 9.60441C3.49958 9.65962 3.49918 9.71792 3.51376 9.77334C3.52834 9.82875 3.55736 9.87931 3.59788 9.91983C3.63839 9.96036 3.68893 9.9894 3.74435 10.004C3.79976 10.0186 3.85806 10.0182 3.91327 10.0029L6.65558 9.24318C6.70947 9.22826 6.75857 9.19964 6.79811 9.1601L12.5742 3.38377C13.1423 2.81436 13.1423 1.89266 12.5742 1.32328L12.1943 0.943343ZM5.06304 6.93003L9.79046 2.20251L11.3151 3.72713L6.58756 8.45465L5.06304 6.93003ZM4.7585 7.54114L5.97651 8.75931L4.29169 9.22612L4.7585 7.54114ZM12.1164 2.92593L11.773 3.26925L10.2483 1.74451L10.5918 1.40115C10.9078 1.08509 11.4203 1.08509 11.7363 1.40115L12.1164 1.78106C12.4319 2.09751 12.4319 2.60961 12.1164 2.92593Z"
                                  fill="#414141"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_101_3493">
                                  <rect
                                    width="13"
                                    height="13"
                                    fill="white"
                                    transform="translate(0 0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </a>
                        <a title="View" style={{ cursor: "pointer" }}>
                          <div
                            className="view-icon-eye"
                            onClick={() => handleGetByIdDocument(data.id)}
                          >
                            <svg
                              width="15"
                              height="14"
                              viewBox="0 0 23 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.2772 7.20095L11.2775 7.20124C11.3939 7.3299 11.5511 7.37848 11.6814 7.39721C11.8148 7.41637 11.9605 7.41017 12.1008 7.39443C12.3541 7.36601 12.647 7.29888 12.913 7.23793C12.9403 7.23166 12.9674 7.22546 12.9941 7.21937C13.2974 7.15023 13.5476 7.09773 13.7196 7.09394C13.7326 7.09365 13.7442 7.09369 13.7544 7.09395C13.7039 8.25914 12.7191 9.20018 11.5 9.20018C10.2472 9.20018 9.24355 8.20822 9.24355 7C9.24355 5.80607 10.2236 4.82332 11.4557 4.80024C11.4558 4.80514 11.4559 4.81046 11.4558 4.81623C11.4552 4.96226 11.401 5.18477 11.3211 5.47591C11.3128 5.50623 11.3042 5.53716 11.2955 5.56858C11.2267 5.81731 11.1493 6.09697 11.1129 6.34728C11.0922 6.48979 11.082 6.63906 11.0991 6.77985C11.1162 6.92086 11.1636 7.07498 11.2772 7.20095ZM0.3 7C0.3 6.99221 0.303779 6.95415 0.330103 6.87721C0.354936 6.80463 0.394591 6.71243 0.451398 6.60209C0.564888 6.38165 0.7391 6.10377 0.975787 5.78837C1.44872 5.15817 2.16041 4.3924 3.10559 3.65187C4.99442 2.17201 7.80594 0.8 11.5 0.8C15.1935 0.8 18.005 2.172 19.894 3.65187C20.8392 4.39241 21.551 5.15819 22.0241 5.78839C22.2608 6.10379 22.4351 6.38167 22.5486 6.60211C22.6054 6.71245 22.6451 6.80466 22.6699 6.87724C22.6962 6.95417 22.7 6.99222 22.7 7C22.7 7.00045 22.7 6.99965 22.7 7.00016C22.7 7.00069 22.7 7.00003 22.7 7.00063L22.6999 7.00247L22.6992 7.00951C22.6985 7.01572 22.6971 7.02421 22.6948 7.03514C22.6902 7.05728 22.6823 7.0862 22.6699 7.12227C22.6451 7.19475 22.6054 7.28687 22.5486 7.39715C22.4351 7.61745 22.2608 7.89525 22.0241 8.21061C21.551 8.84073 20.8392 9.60659 19.894 10.3473C18.005 11.8274 15.1934 13.2 11.5 13.2C7.80598 13.2 4.99446 11.8274 3.10561 10.3473C2.16042 9.6066 1.44872 8.84074 0.975773 8.21063C0.739078 7.89528 0.564857 7.61748 0.451361 7.39717C0.39455 7.2869 0.354896 7.19478 0.330067 7.1223C0.31771 7.08622 0.309813 7.0573 0.305159 7.03515C0.30286 7.02422 0.301521 7.01574 0.300779 7.00952L0.300108 7.00248L0.300014 7.00063C0.299992 7.00003 0.300008 7.00069 0.300002 7.00016C0.29999 6.99965 0.299997 7.00045 0.3 7ZM6.08825 7C6.08825 9.9333 8.51741 12.2992 11.5 12.2992C14.4827 12.2992 16.9106 9.93321 16.9106 7C16.9106 4.06697 14.4829 1.69848 11.5 1.69848C8.51722 1.69848 6.08825 4.06688 6.08825 7Z"
                                stroke="#414141"
                                strokeWidth="0.6"
                              />
                            </svg>
                          </div>
                        </a>
                        <DeleteDocument
                          id={data.id}
                          communityIdForDoc={communityIdForDoc}
                          page={page}
                          pageSize={pageSize}
                          search={search}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
                {allDocs?.data?.length === 0 && (
                  <tr>
                    <td colSpan="6">No Documents Uploaded</td>
                  </tr>
                )}
              </tbody>
            </table>
            <PaginationComponent
              count={count}
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setPage={setPage}
            />
          </div>
        </>
      )}
      <EditDocument
        show={modalShow}
        onHide={() => setModalShow(false)}
        fileNameToEdit={fileNameToEdit}
        versionDateToEdit={versionDateToEdit}
        documentIdForEdit={documentIdForEdit}
        refetch={() => setRefetch(!refetch)}
        community_id_for_doc={communityIdForDoc}
        page={page}
        pageSize={pageSize}
        search={search}
      />
    </div>
  );
};

export default DocumentTable;
